<template>
  <div >
    <div class="commn">
      <div class="alert-box">
        <Alert show-icon closable>注：教师只需要批改简答题。单选题、多选题、判断题已经自动批改完毕。</Alert>
      </div>
      <div class="start-box">
        <Details></Details>
        <hr/>
        <div class="exercises-list-box">
          <ul>
            <li class="exercises-item open" v-for="(item,index) in question_banks_list" :key="index">
              <div class="exercises-item-title">
                <span class="exercises-item-title-name" v-show="item.question_type==1">{{index+1}}、单选题</span>
                <span class="exercises-item-title-name" v-show="item.question_type==2">{{index+1}}、多选题</span>
                <span class="exercises-item-title-name" v-show="item.question_type==3">{{index+1}}、判断题</span>
                <span class="exercises-item-title-name" v-show="item.question_type==4">{{index+1}}、解答题</span>
              </div>
              <div class="exercises-item-question">
                <div class="question-item" v-for="(it,idx) in item.question_list" :key="it.id">
                  <div v-if="item.question_type == 1 || item.question_type == 2 || item.question_type == 3">
                    <div class="question-content">
                      <div class="question-content-title">
                        <span class="question-content-title-name">{{idx+1}}、 {{it.content}}</span>
                        <span class="score-txt">{{it.score}}分</span>
                        <span class="err-txt" v-show="it.confirm_answer != it.answer">回答错误</span>
                        <span class="success-txt" v-show="it.confirm_answer == it.answer">回答正确</span>
                      </div>
                      <div class="question-answer" v-if="item.question_type == 1 || item.question_type == 3">
                        <RadioGroup v-model="it.confirm_answer" class="radio-group">
                          <Radio disabled class="radio" v-for="(value, key, i) in it.option_object" :key="i" :label="key">
                            <em>{{key}}</em>
                            <span class="question-answer-details" >{{value}}</span>
                          </Radio>
                        </RadioGroup>
                        <span class="score-txt" v-show="it.confirm_answer != it.answer">正确答案：{{it.answer}}</span>
                      </div>
                      <div class="question-answer" v-else>
                        <CheckboxGroup v-model="it.confirm_answer_list" class="radio-group">
                          <Checkbox disabled class="radio" v-for="(value, key, i) in it.option_object" :key="i" :label="key">
                            <em style="padding-left: 5px">{{key}}</em>
                            <span class="question-answer-details" >{{value}}</span>
                          </Checkbox>
                        </CheckboxGroup>
                        <span class="score-txt" v-show="it.confirm_answer != it.answer">正确答案：{{it.answer}}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.question_type == 4">
                    <div class="question-content">
                      <div class="question-content-title">
                        <span class="question-content-title-name">{{idx+1}}、 {{it.content}}</span>
                        <span class="score-txt">{{it.score}}分</span>
                      </div>
                      <div class="question-answer">
                        <div style="margin: 10px 0;">学生答案：{{it.confirm_answer}}</div>
                        <div style="margin: 10px 0;">参考答案：{{it.thinking}}</div>
                        <div style="margin: 10px 0;">打分：<InputNumber
                        :max="it.score"
                        :min="1"
                        v-model="it.correct_score"></InputNumber></div>
                        <div style="margin: 10px 0;">评语：
                          <Input v-model="it.correct_comment" type="textarea" :rows="4" placeholder="请输入评语" style="width: 50%"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <Button type="primary" @click="submitAnswer" class="start-answer">提交</Button>
          <Button  @click="cancelAnswer" class="start-answer">取消</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Details from '../../../exercise/common/details'
  import {mapActions,mapState} from "vuex";

  export default {
    name: "start",
    data() {
      return {
        answerPage:false,
        question_banks_list:[]
      }
    },
    props:{
      labwork_id:Number,
      test_paper_id:Number
    },
    components: {
      Details
    },
    computed: {

    },
    methods: {
      ...mapActions({
        submitCorrect:'teachingScore/submitCorrect',
        getQbresult:'teachingScore/getQbresult',
      }),
      startAnswer() {
        this.answerPage = true
      },
      cancelAnswer(){
        this.$parent.scorePage = false
      },
      submitAnswer(){
        let _this = this
        let param = {
          id:_this.labwork_id,
          question_banks:[]
        }
        this.question_banks_list.forEach(item =>{
          if(item.question_type == 4){
            item.question_list.forEach(it =>{
              param.question_banks.push({
                question_bank_id:it.id,
                score:it.correct_score,
                comment:it.correct_comment
              })
            })
          }
        })
        this.submitCorrect({
          data:param,
          callback:res =>{
            _this.$Message.success(res.status.message)
            _this.cancelAnswer()
          },
          err:res =>{
            _this.$Message.error(res.message)
          }
        })
      }
    },
    mounted() {
      let _this = this
      this.getQbresult({
        id:_this.labwork_id,
        callback:res =>{
          let question_banks = []
          res.forEach(item =>{
            question_banks.push(JSON.parse(JSON.stringify(item)))
          })
          this.question_banks_list = question_banks
        }
      })
    },
  }
</script>

<style scoped lang="less">
  @import "../../../../assets/style/exercises";
  .commn {
    max-width: 1360px;
    margin-left: auto;
    margin-right: auto;

    .alert-box {
      margin: 20px 0;
    }

    .start-box {
      padding: 20px;
      box-sizing: border-box;
      background-color: #fff;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, .2);
      margin-bottom: 20px;
      .start-answer{
        margin: 20px 20px 20px 0;
      }
    }
  }
</style>
